import { render, staticRenderFns } from "./PricesForm.vue?vue&type=template&id=955c22d8"
import script from "./PricesForm.vue?vue&type=script&lang=ts"
export * from "./PricesForm.vue?vue&type=script&lang=ts"
import style0 from "./PricesForm.vue?vue&type=style&index=0&id=955c22d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports